module.exports = __webpack_public_path__ + "img/41.c77b8f5c.jpg";